import styled from 'styled-components/macro';

const RegistrationHeader = styled.h3<{ mb?: boolean }>`
  margin-bottom: ${({ theme, mb }) => (mb ? theme.spacing.zero_2 : theme.spacing.two_2)};

  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.xxl};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  font-weight: 400;
  text-align: center;
`;

export default RegistrationHeader;
